export const publicWebsiteIsDisney = (motifKeys?: string[]): boolean => {
  if (motifKeys && motifKeys.length > 0) {
    const disneyMotif = motifKeys.filter(motif => motif === 'Disney');
    return disneyMotif.length > 0;
  }
  return false;
};

export default publicWebsiteIsDisney;
